// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"668f3da0","732":"1bcfaac9","977":"3a4741be"}[chunkId] + ".chunk.js";
};